<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card
          :header-html="header"
          class="title-inline"
          header-class="card-custom-header"
        >
          <b-card-text>
            <!--            <div v-if="currentCloud.plan === null" class="promo-box">-->
            <!--              <i class="fas fa-percent"></i> PROMOCJA: {{ program.toUpperCase()-->
            <!--              }}<sup>®</sup> w Chmurze za 0zł ! Aby skorzystać, przejdź do-->
            <!--              podsumowania i wyślij zamówienie. Oferta ważna do 30.09.2021 r.-->
            <!--            </div>-->
            <div class="accordion order-card" role="tablist" id="cloud">
              <b-card no-body class="mb-1 noborder-card">
                <b-card-body>
                  <b-card-text class="px-2">
                    <p>
                      <span v-html="description"></span>

                      <a :href="web" target="_blank">Dowiedz się więcej ></a>
                    </p></b-card-text
                  >
                  <b-card-text>
                    <b-col lg="12" class="font-italic info-text">
                      <i class="fas fa-exclamation-circle"></i>
                      <span v-html="paymentInfo"></span>
                    </b-col>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </div>
            <div class="order-card">
              <b-card no-body class="mb-1 remove-borders">
                <b-card-header
                  header-tag="header"
                  class="p-1 font-weight-bold h6"
                >
                  Wybór pakietu
                </b-card-header>
                <b-card-body class="pb-0">
                  <b-card-text v-html="package_info"></b-card-text>
                  <b-card-text v-if="isAccountant">
                    <i class="far fa-calendar-alt"></i
                    ><span class="font-weight-bold"> Ważne!</span> Abonament
                    sprzedawany jest na pełne miesiące.
                  </b-card-text>
                  <b-card-text v-if="isAccountant"
                    >W ciągu trwania abonamentu zawsze możesz wejść na wyższy
                    pakiet, ale nigdy na niższy. W tym celu zaznacz wyższy
                    pakiet. Gdy kupiłeś pakiet z rabatem zachowasz go a różnica
                    w cenie zostanie doliczona począwszy od następnego miesiąca
                    kalendarzowego.
                  </b-card-text>
                  <b-card-text
                    v-if="isDiscount649 || isDiscount656_657"
                    class="promo-box font-weight-light"
                  >
                    <span class="info-text" v-if="isAccountant">
                      % PROMOCJA: Usługa on-line SKP24 Connect Biuro ZA DARMO do
                      końca 2024.<br />
                      Aby skorzystać z promocji wybierz abonament
                      <strong>EXTRA do 10 klientów</strong>, następnie kliknij:
                      <strong>Zaznacz wszystkie miesiące.</strong>
                    </span>
                    <span class="info-text" v-else>
                      % PROMOCJA: Usługa on-line SKP24 Connect Firma ZA DARMO do
                      końca 2024.<br />
                      Aby skorzystać z promocji kliknij:
                      <strong>Zaznacz wszystkie miesiące.</strong>
                    </span>
                  </b-card-text>
                  <b-card-text
                    v-else-if="
                      isAccountant && cloudNeverHave && isDiscount622_623
                    "
                    ><span class="info-text"
                      ><strong>Uwaga PROMOCJA!</strong> W abonamencie na minimum
                      6 miesięcy otrzymasz – <strong>35% RABATU</strong>, a w
                      rocznym aż <strong>50% RABATU!</strong> Promocja
                      obowiązuje <strong>do 31.01.2023 r.</strong></span
                    >
                  </b-card-text>
                  <b-row>
                    <b-col
                      v-for="option in cloudOptionsPrepared"
                      :key="option.value"
                      class="col-width"
                      :lg="columns"
                    >
                      <OrderCloudPlan
                        :cloudOptions="cloudOptions"
                        :selectedPlan="selectedPlan"
                        :selectedMonths="selectedMonths"
                        :cloudNeverHave="cloudNeverHave"
                        :isDiscount622_623="isDiscount622_623"
                        :isDiscount656_657="isDiscount656_657"
                        :isDiscount649="isDiscount649"
                        :option="option"
                        :isAccountant="isAccountant"
                        :skpAdd="skpAdd"
                        :skpCompanyAdd="skpCompanyAdd"
                        :skpAccountantAdd="skpAccountantAdd"
                        :styles="styles"
                        v-on:selectplan="selectPlan"
                        v-on:selectmonths="selectMonths"
                        v-on:updatetotal="updateTotal"
                      ></OrderCloudPlan>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </div>
            <b-row v-if="errors.length || secondErrors.length"
              ><p></p>
              <ul>
                <li v-for="error in errors" :key="error" class="text-danger">
                  {{ error }}
                </li>
                <li
                  v-for="error in secondErrors"
                  :key="error"
                  class="text-danger"
                >
                  {{ error }}
                </li>
              </ul>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <p
        class="bot-link"
        style="color: #1292a8; margin-left: 20px"
        @click="runChat"
      >
        <strong>Potrzebujesz szybkiej pomocy?<br /></strong>
        Zapytaj Wirtualnego Asystenta SKP<sup>®</sup> >
      </p>
      <b-button
        variant="secondary"
        class="mx-3 ml-auto my-1 btn-color"
        @click="backStep"
        >Wstecz
      </b-button>
      <b-button
        variant="success"
        class="mx-3 my-1 btn-accept-color"
        @click="forwardStep"
        >Dalej
      </b-button>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { accountant, company } from '../../config/cloud';
import helper from './config/helperData';
import OrderCloudPlan from './OrderCloudPlan';
import NumbersHelper from '../../../helper/numbersHelper';
import moment from 'moment';

export default {
  name: 'OrderCloud',
  components: { OrderCloudPlan },
  props: {
    cloudOptions: {},
    cloudNeverHave: { type: Boolean, default: false },
    isDiscount622_623: { type: Boolean, default: false },
    isDiscount656_657: { type: Boolean, default: false },
    cloudDiscount: { default: false },
    isAccountant: { type: Boolean, default: false },
    skpAdd: { default: null },
    skpCompanyAdd: { type: Boolean, default: false },
    skpAccountantAdd: { type: Boolean, default: false },
    program: {},
    styles: {},
  },
  data() {
    return {
      errors: [],
      secondErrors: [],
      currentMonths: [],
      year: process.env.MIX_AKTU_YEAR,
      confirmMessage: '',
      monthEnding: process.env.MIX_MONTH_ENDING,
    };
  },
  created() {
    this.currentMonths = this.selectedMonths;
  },
  computed: {
    ...mapGetters({
      client: 'auth/client',
      licence: 'auth/userLicence',
      cloudPlan: 'order/cloudPlan',
      cloudMonths: 'order/cloudMonths',
      freeCloudUsed: 'order/freeCloudUsed',
      currentCloud: 'order/currentCloud',
      currentOs: 'auth/currentOs',
      cloudCartTotal: 'order/cloudCartTotal',
      cartProducts: 'order/getCartProducts',
      cartCloud: 'order/cartCloud',
      cloudNeverHave2024: 'auth/cloudNeverHave2024',
    }),
    freeCloudData() {
      return this.freeCloudUsed;
    },
    isDiscount649() {
      return typeof this.cloudDiscount === 'object' &&
        this.cloudDiscount !== null
        ? this.cloudDiscount.id === 649 && this.cloudNeverHave2024
        : false;
    },
    header() {
      return this.isAccountant || this.skpAccountantAdd
        ? 'SKP24 Connect Biuro - dodatkowa usługa do wyboru'
        : this.program === 'sam' && !this.skpCompanyAdd
        ? 'SAM<sup>®</sup> Firma w Chmurze - dodatkowa usługa do wyboru'
        : 'SKP24 Connect Firma - dodatkowa usługa do wyboru';
    },
    title() {
      return this.isAccountant ? accountant.title : company.title;
    },
    description() {
      return this.isAccountant ? accountant.description : company.description;
    },
    web() {
      return this.program === 'sam'
        ? 'https://www.samozatrudnienie.pl/o-programie/chmura'
        : this.isAccountant
        ? accountant.web
        : company.web;
    },
    package_info() {
      return this.isAccountant
        ? 'Wybierz odpowiedni do swoich potrzeb pakiet, związany z liczbą Klientów obsługiwanych w SKP24 Connect Biuro.<br>' +
            accountant.package_info
        : company.package_info;
    },
    free_title() {
      return this.isAccountant ? accountant.free_title : company.free_title;
    },
    selectedPlan() {
      return this.cloudPlan;
    },
    selectedMonths() {
      return this.cloudMonths;
    },
    freeError() {
      if (this.currentMonths.length === 2) {
        let months = this.currentMonths;

        months.sort(function (a, b) {
          return a - b;
        });

        return months[0] !== months[1] - 1;
      }

      return false;
    },
    paymentInfo() {
      return (
        'Uwaga! W celu otrzymania natychmiastowego dostępu do usługi ' +
        this.header +
        ' zalecamy wybór płatności PayU (przelew online/płatność kartą). Przy wyborze innej formy płatności, usługa będzie dostępna po jej zaksięgowaniu.'
      );
    },
    validateCount() {
      if (this.selectedPlan === 0) {
        return this.currentMonths.length > 2;
      }

      return false;
    },
    total() {
      return this.cloudCartTotal;
    },
    cloudOptionsPrepared() {
      if (this.freeCloudData || this.currentCloud.plan) {
        let options = [];
        Object.entries(this.cloudOptions).forEach(([key, item]) => {
          if (item.value !== 0) {
            if (
              this.currentCloud.plan !== 77 &&
              this.currentCloud.plan !== 80 &&
              item.value < this.currentCloud.plan
            ) {
              item['disabled'] = true;
            }
            options.push(item);
          }
        });
        return options;
      }
      return this.cloudOptions;
    },
    columns() {
      if (Object.keys(this.cloudOptionsPrepared).length > 4) {
        return '';
      } else {
        return 3;
      }
    },
    allProducts() {
      let products = [];

      if (
        !this.currentOs &&
        !this.skpAdd &&
        !(
          localStorage.getItem('staffName') === 'formsoft' &&
          localStorage.getItem('staffId') === '0'
        )
      ) {
        let osName;
        if (this.program == 'sam') {
          osName = 'Bezpłatne przejście na SKP® z Opieką Serwisową ';
        } else {
          osName = 'Opieka Serwisowa ';
        }
        products.push({
          label: osName + this.year,
          net: this.osPrice,
          vat: 23,
          gross: this.osPriceGross,
          quantity: 1,
        });
      }

      if (typeof this.cartCloud !== 'undefined' && this.cartCloud.length > 0) {
        this.cartCloud.forEach((item) => {
          products.push({
            label: item.label,
            quantity: item.quantity,
            net: item.net,
            vat: item.vat,
            gross: item.gross,
          });
        });
      }

      if (this.changeLicence) {
        products.push({
          label: 'Przeniesienie licencji',
          net: this.changeLicence.NETTO,
          vat: this.changeLicence.VAT,
          gross: this.changeLicence.BRUTTO,
        });
      }

      if (
        typeof this.cartProducts !== 'undefined' &&
        this.cartProducts.length > 0
      ) {
        this.cartProducts.forEach((item) => {
          products.push({
            label: this.isTransferFromSamToSkp(item)
              ? this.addedSkpTitle
              : item.label
              ? item.label
              : item.OPIS,
            quantity: item.quantity,
            net: item.NETTO,
            vat: item.VAT,
            gross: item.BRUTTO,
          });
        });
      }

      products.sort(function (a, b) {
        return (
          (a.label === 'Zryczałtowany koszt przesyłki Kurier / Poczta Polska') -
          (b.label === 'Zryczałtowany koszt przesyłki Kurier / Poczta Polska')
        );
      });

      this.$store.commit('order/setSummaryProducts', products);

      return products;
    },
  },
  methods: {
    forwardStep() {
      this.errors = [];
      this.secondErrors = [];
      this.validateCloudOrder();
      let msg = '';

      if (this.errors.length === 0) {
        this.updateCloud();
        this.validateCountProducts();
        if (this.secondErrors.length === 0) {
          this.$store.commit('order/incrementStep');
        }
      }
    },
    backStep() {
      this.errors = [];
      this.secondErrors = [];
      this.validateCloudOrder();
      if (this.errors.length === 0) {
        this.updateCloud();
        this.$store.commit('order/decrementStep');
      }
    },
    validateCloudOrder() {
      if (this.freeError && this.selectedPlan === 0) {
        this.errors.push('Wybierz dwa następujące po sobie miesiące.');
      }

      if (this.validateCount) {
        this.errors.push(
          'Dostępne są tylko dwa miesiące próbne. Jeżeli chcesz dostęp w kolejnych miesiącach zamów płatny abonament.'
        );
      }

      if (
        this.currentMonths.length < 1 &&
        this.selectedPlan !== this.currentCloud.plan &&
        this.selectedPlan !== null &&
        !this.selectedPlan.toString().includes('year')
      ) {
        this.errors.push('Wybierz miesiąc.');
      }
    },
    updateCloud() {
      let that = this;
      this.$store.commit('order/removeCloudProducts');

      if (this.selectedPlan !== null) {
        if (this.selectedPlan.toString().includes('year')) {
          this.currentMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        } else {
          this.currentMonths.sort(function (a, b) {
            return a - b;
          });
        }
        let fullYearDiscount = this.currentMonths.length === 12;
        let halfYearDiscount = this.currentMonths.length >= 6;
        this.$store.commit('order/setCloudMonths', this.currentMonths);

        let planId = this.selectedPlan.toString().replace('_year', '');
        let product = this.cloudOptions[planId];

        let activateDiscount649 = false;
        if (
          (this.isDiscount649 || this.isDiscount656_657) &&
          [72, 77].includes(parseInt(planId)) &&
          12 - this.currentMonths.length ===
            new Date().getMonth() +
              (new Date().getDate() >= parseInt(this.monthEnding) ? 1 : 0)
        ) {
          activateDiscount649 = true;
        }
        this.currentMonths.forEach(function (month) {
          // prevent adding passed month
          if (month <= new Date().getMonth()) {
            return;
          }
          let net = 0;
          if (
            that.currentCloud.months.includes(month) &&
            that.cloudOptions[planId].net > that.currentCloud.price
          ) {
            net = that.cloudOptions[planId].net - that.currentCloud.price;
          } else {
            net = that.cloudOptions[planId].net;
          }

          if (activateDiscount649) {
            net = 0;
          } else if (
            that.isAccountant &&
            that.cloudNeverHave &&
            that.isDiscount622_623
          ) {
            if (fullYearDiscount) {
              net = (net * 50) / 100;
            } else if (halfYearDiscount) {
              net = (net * 65) / 100;
            }
          } else {
            if (fullYearDiscount) {
              net = (net * 85) / 100;
            } else if (halfYearDiscount) {
              net = (net * 90) / 100;
            }
          }

          let program =
            that.skpAdd && that.skpAdd.length > 0
              ? 'skp'.toUpperCase()
              : that.program.toUpperCase();
          let title = that.skpAccountantAdd
            ? 'SKP24 Connect Biuro'
            : that.title;
          let packageText =
            that.isAccountant || that.skpAccountantAdd
              ? ', pakiet ' + product.text
              : '';

          net = NumbersHelper.toFixedTrunc(net, 2);
          that.$store.commit('order/addCloud', {
            label:
              title +
              packageText +
              ': ' +
              helper.months[month] +
              ' ' +
              moment().format('YYYY'),
            net: net,
            vat: 23,
            gross: NumbersHelper.toFixedTrunc((net * 123) / 100, 2),
            quantity: 1,
          });
        });
      }
    },
    selectPlan(value, event) {
      this.currentMonths = [];
      this.$store.commit('order/clearCloudMonths');
      this.$store.commit('order/setCloudPlan', value);
    },
    selectMonths(value) {
      this.currentMonths = value;
      this.errors = [];
      this.secondErrors = [];
    },
    updateTotal(value) {
      this.$store.commit('order/setCartCloudTotal', value);
    },
    runChat() {
      document.getElementById('chatbase-bubble-button').click();
    },
    isTransferFromSamToSkp(item) {
      return (
        (item.UWAGI === 'N_SKP' && item.key !== 'O') ||
        (this.program === 'sam' &&
          (item.key === 'B1' || item.key === 'B2' || item.key === 'B3'))
      );
    },
    validateCountProducts() {
      if (this.allProducts.length === 0) {
        this.secondErrors.push('Wybierz przynajmniej jeden produkt.');
      }
    },
  },
};
</script>

<style scoped>
.move-left {
  padding-left: 0;
}

.col-width {
  padding-left: 3px;
  padding-right: 3px;
}
</style>
